import { InjectionToken } from '@angular/core';
import { ImageLoadOptionsInterface } from './image-load-options.interface';

export const IMAGE_LOAD_OPTIONS = new InjectionToken<ImageLoadOptionsInterface>('image_load_options');
